import {
  Box,
  Container,
  Image,
  FlexProps,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { Header } from '../../atoms/Header';
import CustomersPlaceholderIcon from '../../../assets/customers-placeholder.png';
import { IS_DEV } from 'src/constants';

export const Testimonials: React.FC<FlexProps> = () => {
  return (
    <Box bg="white" color="text.darkBlue.900" pt={{ base: 16, md: 24 }}>
      <Container maxW="container.xl">
        <Header>
          BUILT FOR MARKETING TEAMS AND MEDIA LEADERS
          {!IS_DEV && (
            <Text
              fontSize="xl"
              color="gray.600"
              fontFamily="marketingPage"
              fontWeight="medium"
              textTransform="uppercase"
              mb={{ base: 8, md: 12 }}>
              Built by founders who’ve delivered Marketing Mix Models across
              b2b, commerce, media, tech, finance, auto, insurance, and health
              care.
            </Text>
          )}
        </Header>
        {IS_DEV && (
          <SimpleGrid
            columns={{ base: 3, sm: 3, md: 3 }}
            spacing={{ base: 4, md: 6 }}>
            {Array.from({ length: 6 }).map((_, index) => (
              <Image
                key={index}
                src={CustomersPlaceholderIcon}
                w="100%"
                h="100%"
                borderRadius="md"
              />
            ))}
          </SimpleGrid>
        )}
      </Container>
    </Box>
  );
};
